import React, { useState, useEffect } from 'react';

/**
 * Indicateur de fraicheur d'une position GPS.
 * 🟢 EN DIRECT (< 1 min) / 🟡 il y a X min (< 5 min) / ⚪ perimee (>= 5 min)
 */
const GpsFreshness = ({ lastUpdate, className = '' }) => {
    const [, setTick] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => setTick(t => t + 1), 15000);
        return () => clearInterval(interval);
    }, []);

    if (!lastUpdate) return null;
    const ageSec = (Date.now() - new Date(lastUpdate).getTime()) / 1000;
    let cfg;
    if (ageSec < 60) {
        cfg = { dot: 'bg-emerald-500 animate-pulse', text: 'text-emerald-400', label: 'EN DIRECT' };
    } else if (ageSec < 300) {
        cfg = { dot: 'bg-amber-400', text: 'text-amber-400', label: `il y a ${Math.round(ageSec / 60)} min` };
    } else {
        const mins = Math.round(ageSec / 60);
        const ago = mins < 60 ? `${mins} min` : mins < 1440 ? `${Math.round(mins / 60)}h` : `${Math.round(mins / 1440)}j`;
        cfg = { dot: 'bg-zinc-500', text: 'text-zinc-500', label: `perimee · il y a ${ago}` };
    }
    return (
        <span className={`inline-flex items-center gap-1.5 text-xs font-medium ${cfg.text} ${className}`} data-testid="gps-freshness">
            <span className={`w-2 h-2 rounded-full flex-shrink-0 ${cfg.dot}`}></span>{cfg.label}
        </span>
    );
};

export default GpsFreshness;
